import { Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import useFlowsHelper from '../../../../../hooks/useFlowsHelper';
import useTagContent from '../../../common/hooks/useTagContent';

const CompanyScanProgressHeader: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const { currentTag } = useFlowsHelper();
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );
  const groups = useFlowsSelector((state) => state.flows.questionnaire.groups);

  const tagContent = useTagContent(currentTag || '');

  return (
    <VStack align="stretch" mb="4">
      <Text color="gray.400" textStyle="smallBody" mb="1">
        {t('FLOWS_COMPANY-SCAN_TOOLBAR_PROGRESS-INDICATION', {
          currentSubjectPosition: (lastPosition || 0) + 1,
          lastSubjectPosition: groups.length,
        })}
      </Text>
      <Text color="gray.500" textStyle="largeBodyMedium">
        {tagContent}
      </Text>
    </VStack>
  );
};

export default CompanyScanProgressHeader;
